import React, { useState, useEffect } from "react";
import { EventNavBarList } from "../components/EventNavBarList";
import { useEventContext } from "../util/EventProvider";
import "./EventListView.scss";
import { CalendarView } from "../components/CalendarView";
import LoadingSpinner from "./LoadingSpinner"; // Import your loading spinner component
import _ from "lodash";
import NoMatch from "./NoMatch"; // Import your no match component

export const EventListView = () => {
  const {
    customEventDetails,
    eventInstances,
    loading,
    priceDetails,
    ticketData,
    studentPrices,
    generalAdmTicketTypeId,
    studentTicketTypeId,
    ticketTypeNames,
    availableStatus,
    customItems,
    list,
  } = useEventContext();

  const [filterTextValue, setFilterTextValue] = useState("Filter Program");
  const [filterTextValueTwo, setFilterTextValueTwo] =
    useState("Filter Instrument");
  const [view, setView] = useState("List");
  const [meetings, setMeetings] = useState([]);

  const [resizeKey, setResizeKey] = useState(0);

  const triggerResize = () => {
    if (typeof window.parentIFrame?.size === "function") {
      setTimeout(() => {
        window.parentIFrame.size();
        console.log("Resize triggered", new Date().toLocaleTimeString());
        setResizeKey((prev) => prev + 1); // Force re-render
      }, 300); // Longer delay for dynamic content
    } else {
      console.warn("parentIFrame not available");
    }
  };

  useEffect(() => {
    console.log("ParentIFrame available?", !!window.parentIFrame);
  }, []);

  useEffect(() => {
    const savedView = localStorage.getItem("selectedView");
    if (savedView) {
      setView(savedView);
    } else {
      localStorage.setItem("selectedView", "List"); // Default to "List"
    }
  }, []);

  //console.log(customEventDetails);

  const formatDate = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "long" });
    const dateNumber = dateObj.getDate();
    const year = dateObj.getFullYear();
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${month} ${dateNumber} • ${time}`;
  };

  // Define the shared style properties for the tag labels
  const tagStyle = {
    padding: "6px", // Add padding to the container
    width: "auto",
    height: "5px",
    fontWeight: "normal", // Apply lighter font weight
    color: "#FFFFFF", // Set text color to white
    letterSpacing: "2px", // Increase letter-spacing to stretch out the text
    lineHeight: "0.1", // Adjust the height of the text
    fontSize: "0.6rem", // Adjust font size to make the text smaller
    background: "#2D2D2D", // Set the background color to white
    fontFamily: "Montserrat, sans-serif",
    textTransform: "uppercase",
  };

  const getDayOfWeek = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj
      .toLocaleDateString("en-US", { weekday: "short" })
      .slice(0, 3);
  };

  const getDateNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.getDate();
  };

  const getMonthName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { month: "long" });
  };

  const getYearName = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleDateString("en-US", { year: "numeric" });
  };

  const getTimeNumber = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  };

  //const [currentMonth, setCurrentMonth] = useState(() => getDate());

  function onFilterValueSelected(filterValue) {
    setFilterTextValue(filterValue);
  }

  function onFilterValueTwoSelected(filterValueTwo) {
    setFilterTextValueTwo(filterValueTwo);
  }

  function onViewValueSelected(viewValue) {
    if (view !== viewValue) {
      setView(viewValue); // Update the view state
      localStorage.setItem("selectedView", viewValue); // Save the selected view to localStorage
    }
  }

  // Initialize an array to store event instances and its event id
  const eventInstancesArray = Object.entries(eventInstances).map(
    ([eventId, instances]) => ({
      eventId,
      eventInstances: instances,
    })
  );

  // Initialize an empty array to store the merged data
  const mergedEventDetails = [];

  // Iterate over one of the arrays, eventInstancesArray in this case
  eventInstancesArray.forEach(({ eventId, eventInstances }) => {
    // Find the corresponding event in filteredEvents array using the Event ID
    const event = list.find((event) => event.id === eventId);

    // If the event is found, merge the data and push it to the mergedArray
    if (event) {
      const instancePrice =
        priceDetails[eventId] !== undefined ? priceDetails[eventId] : null;
      mergedEventDetails.push({
        event,
        eventInstances,
        priceDetails,
        customItems,
        studentPrices,
        generalAdmTicketTypeId,
        studentTicketTypeId,
        ticketTypeNames,
        ticketData,
        availableStatus,
      });
    }
  });

  // Sort the mergedEventDetails array based on eventInstances start times
  mergedEventDetails.sort((a, b) => {
    // Get the start times of the first instance for each event, if available
    const startTimeA =
      a.eventInstances.length > 0 ? new Date(a.eventInstances[0]?.start) : null;
    const startTimeB =
      b.eventInstances.length > 0 ? new Date(b.eventInstances[0]?.start) : null;

    // Handle cases where eventInstances array might be empty or undefined
    if (!startTimeA && !startTimeB) {
      return 0; // If both are null or undefined, consider them equal
    } else if (!startTimeA) {
      return 1; // If startTimeA is null or undefined, b should come first
    } else if (!startTimeB) {
      return -1; // If startTimeB is null or undefined, a should come first
    } else {
      return startTimeA - startTimeB; // Compare the valid start times and return the result
    }
  });

  function sortEventInstancesByDay(eventObject) {
    // Iterate over each event in the object
    for (let i = 0; i < eventObject.length; i++) {
      // Sort the eventInstances array by the start date
      eventObject[i].eventInstances.sort((a, b) => {
        const dateA = new Date(a.start);
        const dateB = new Date(b.start);
        return dateA - dateB;
      });
    }
    // Return the sorted event object
    return eventObject;
  }
  // Example usage:
  const sortedEventObject = sortEventInstancesByDay(mergedEventDetails);

  const transformedEventsTwo = sortedEventObject.map(
    ({
      event,
      eventInstances,
      priceDetails,
      customItems,
      studentPrices,
      studentTicketTypeId,
      generalAdmTicketTypeId,
      ticketTypeNames,
      ticketData,
      availableStatus,
    }) => {
      // Copy all properties of the event object
      const completeEventProperties = { ...eventInstances };

      // Add instances as a separate property
      completeEventProperties.eventDetails = event;

      // Add instances as a separate property
      completeEventProperties.priceDetails = priceDetails;

      // Add instances as a separate property
      completeEventProperties.customItems = customItems;

      // Add instances as a separate property
      completeEventProperties.studentPrices = studentPrices;

      // Add instances as a separate property
      completeEventProperties.studentTicketTypeId = studentTicketTypeId;

      // Add instances as a separate property
      completeEventProperties.generalAdmTicketTypeId = generalAdmTicketTypeId;

      // Add instances as a separate property
      completeEventProperties.ticketTypeNames = ticketTypeNames;

      // Add instances as a separate property
      completeEventProperties.ticketData = ticketData;

      // Add instances as a separate property
      completeEventProperties.availableStatus = availableStatus;

      // Return the new object
      return completeEventProperties;
    }
  );

  // Create an object to hold the grouped events
  const groupedEvents = {};

  // Iterate over the transformedEventsTwo and group events by date
  Object.values(transformedEventsTwo).forEach((events) => {
    // Check if events array is not empty and the first event has a valid start property
    if (events.length > 0 && events[0].start) {
      const startDate = events[0].start.substring(0, 10); // Extract date part of the start time

      // Check if the date already exists in groupedEvents
      if (groupedEvents[startDate]) {
        // If the date exists, push all instances from 'events' to the corresponding array
        groupedEvents[startDate].push(...events);
      } else {
        // If the date doesn't exist, create a new array with instances from 'events'
        groupedEvents[startDate] = [...events];
      }
    } else {
      console.error(
        "Invalid event structure: start property not found or events array is empty"
      );
      // Handle the case where events[0] or events[0].start is undefined or null
    }
  });

  const currentDate = new Date();

  // Filter the sortedEventList to include only events that have not passed
  const filteredEvents = customEventDetails.filter((event) => {
    const eventDate = new Date(event.start);
    return eventDate >= currentDate;
  });

  const filteredEventList = filteredEvents.filter((event) => {
    const filterByProgram =
      filterTextValue === "Filter Program" ||
      filterTextValue === event.attribute_EventCategory;

    const filterByInstrument =
      filterTextValueTwo === "Filter Instrument" ||
      filterTextValueTwo === event.attribute_EventTag2;
    return filterByProgram && filterByInstrument;
  });

  // Define a constant to represent when no matches are present
  const noMatchView = filteredEventList.length === 0;

  // Function to execute when there are no matches
  const handleNoMatch = () => {
    return <NoMatch />;
    //console.log("No matches found between filters!");
  };

  // Check if there are no matches and execute the function
  if (noMatchView && loading === false) {
    handleNoMatch();
  }

  // Get unique months from the filteredEventList
  const uniqueMonths = Array.from(
    new Set(
      filteredEventList.map(
        (event) => `${getMonthName(event.start)} ${getYearName(event.start)}`
      )
    )
  );

  useEffect(() => {
    // Filter customEventDetails to include only events with isOnSale true and a defined start property
    const filteredMeetings = customEventDetails.filter(
      (event) => event && event.isOnSale && event.start
    );

    // Check if meetings need to be updated before setting state
    if (JSON.stringify(filteredMeetings) !== JSON.stringify(meetings)) {
      // Set the meetings state once with filteredMeetings
      setMeetings(filteredMeetings);
      triggerResize();
    }
  }, [customEventDetails, meetings]); // Add meetings as a dependency

  uniqueMonths.sort((a, b) => {
    // Extract year and month from each string (e.g., "February 2024")
    const [monthA, yearA] = a.split(" ");
    const [monthB, yearB] = b.split(" ");
    // Compare years first
    if (yearA !== yearB) {
      return parseInt(yearA) - parseInt(yearB);
    } else {
      // If years are the same, compare months
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months.indexOf(monthA) - months.indexOf(monthB);
    }
  });

  const formatMonthYearDisplay = (monthYear) => {
    const monthAbbreviations = {
      January: "JAN",
      February: "FEB",
      March: "MAR",
      April: "APR",
      May: "MAY",
      June: "JUN",
      July: "JUL",
      August: "AUG",
      September: "SEPT", // Special 4-letter case
      October: "OCT",
      November: "NOV",
      December: "DEC",
    };

    const [month, year] = monthYear.split(" ");

    // Only abbreviate if month has 5+ characters
    const displayMonth =
      month.length > 5
        ? monthAbbreviations[month] || month.slice(0, 3).toUpperCase()
        : month.toUpperCase(); // Keep short months full-length

    return `${displayMonth} ${year}`;
  };

  useEffect(() => {
    const debugSpacing = () => {
      const allElements = Array.from(document.querySelectorAll("*"));
      const bottomElements = allElements
        .filter((el) => {
          const rect = el.getBoundingClientRect();
          return rect.bottom > window.innerHeight - 20;
        })
        .map((el) => {
          const rect = el.getBoundingClientRect(); // Define rect here again
          return {
            element: el.tagName,
            class: el.className,
            id: el.id,
            bottom: rect.bottom,
          };
        });

      console.table(bottomElements);
      triggerResize();
    };

    const timer = setTimeout(debugSpacing, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Fix common spacing offenders
    const style = document.createElement("style");
    style.textContent = `
      body > *:last-child {
        margin-bottom: 0 !important;
      }
      .event-footer, [class*="-container"] {
        padding-bottom: 0 !important;
      }
    `;
    document.head.appendChild(style);

    return () => document.head.removeChild(style);
  }, []);

  // Render list items
  const listItems = uniqueMonths.map((monthYear) => {
    const eventsForMonth = filteredEventList.filter((event) => {
      const eventMonthYear = `${getMonthName(event.start)} ${getYearName(
        event.start
      )}`;
      return eventMonthYear === monthYear;
    });

    // Sort events for the month by start date
    const orderedByDay = eventsForMonth.sort((a, b) => {
      const dateA = new Date(a.start);
      const dateB = new Date(b.start);
      //setOrderedList(orderedByDay);
      return dateA - dateB;
    });

    function areAllInstancesSoldOutForDay(orderedByDay, eventId, day) {
      // Group instances by day and event ID
      const instancesGroupedByDayAndEventId = {};

      orderedByDay.forEach((instance) => {
        const instanceDay = instance.start.split("T")[0]; // Extracting the date from the timestamp
        const instanceEventId = instance.id;

        // Creating a unique key for each day and event ID combination
        const key = `${instanceDay}-${instanceEventId}`;

        if (!instancesGroupedByDayAndEventId[key]) {
          instancesGroupedByDayAndEventId[key] = [];
        }
        instancesGroupedByDayAndEventId[key].push(instance);
      });

      // Get instances of the given event happening on the provided day
      const key = `${day}-${eventId}`;
      const instancesOnDayAndEventId =
        instancesGroupedByDayAndEventId[key] || [];
      //console.log(instancesOnDayAndEventId);
      // Check if all instances for the day and event ID are sold out
      const allSoldOut = instancesOnDayAndEventId.every(
        (instance) => instance.availableStatus === 0
      );
      return { allSoldOut, instancesOnDayAndEventId };
    }

    // Define an array to store the keys of rendered events
    const renderedEventKeys = new Set();

    const handleLinkClick = (path, eventDate, eventId) => {
      // Store customEventDetails and eventDate in local storage
      //localStorage.setItem('customEventDetails', JSON.stringify(customEventDetails));
      localStorage.setItem("eventDate", eventDate);
      localStorage.setItem("eventIdTwo", eventId);

      // Navigate the parent window to the specified path
      window.parent.location.href = path;

      console.log("Message from iframe:", path);
    };

    // Add this helper function at the top of your component:
    const isLastEventInMonth = (currentEvent) => {
      // Find all visible events in the same month
      const eventsInMonth = orderedByDay.filter(
        (e) =>
          !e.attribute_HideEvent &&
          new Date(e.start).getMonth() ===
            new Date(currentEvent.start).getMonth() &&
          new Date(e.start).getFullYear() ===
            new Date(currentEvent.start).getFullYear()
      );

      // Check if current event is the last one
      return eventsInMonth[eventsInMonth.length - 1].id === currentEvent.id;
    };

    //console.log(customEventDetails);
    localStorage.setItem(
      "customEventDetails",
      JSON.stringify(customEventDetails)
    );
    localStorage.setItem("eventInstancesTwo", JSON.stringify(eventInstances));

    function checkEventInUniqueMonths(event) {
      // Generate a unique key for the event instance
      const eventKey = `${event.id}-${getDateNumber(event.start)}`;

      // Example usage
      const eventId = event.id; // Event ID to check
      const day = event.start.split("T")[0]; // Day to check (extracting date from timestamp)

      const { allSoldOut, instancesOnDayAndEventId } =
        areAllInstancesSoldOutForDay(orderedByDay, eventId, day);
      //console.log(instancesOnDayAndEventId);

      //console.log(eventInstances);

      // Utility function to shorten the ID
      const shortenId = (id) => id.substring(0, 5);

      // Check if the event key exists in the array of rendered event keys
      if (!renderedEventKeys.has(eventKey)) {
        // Add the event key to the array of rendered event keys
        renderedEventKeys.add(eventKey);

        // Return JSX to render the event
        return !event.attribute_HideEvent ? (
          <div
            className="my-5 animate-fadeFromBottom Precheckout pre-checkout-container"
            style={{
              minHeight: "auto",
              maxHeight: "100%",
              width: "100%",
              height: "100%",
              justifyContent: "flex-start", // Align items to the furthest left
            }}
          >
            {" "}
            {/* Ensure each key is unique */}
            <li
              className="content-center"
              key={event.instanceId}
              style={{ minHeight: "200px", minWidth: "100%", maxWidth: "100%" }}
            >
              {/*existing event instance rendering logic */}
              <div class="grid place-content-center gap-1 sm:grid-cols-1 md:grid-cols-9">
                <div class="justify-end pb-2">
                  <div class="justify-end">
                    <div
                      className="text-center hidden xsm:block"
                      style={{ width: "fit-content" }}
                    >
                      {event.start && (
                        <p
                          className="leading-tight text-xxxs sm:text-xl"
                          id=""
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontWeight: "normal",
                          }}
                        >
                          {getDayOfWeek(event.start)}
                        </p>
                      )}
                      {event.start && (
                        <h1
                          className="uppercase text-xxs sm:text-xxl"
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "none",
                            fontWeight: "800",
                            lineHeight: "1",
                          }}
                        >
                          {getDateNumber(event.start)}
                        </h1>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  class="md:col-span-4"
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="md:divide-x lg:divide-x"
                    style={{ flex: "1", maxWidth: "400px" }}
                  >
                    <div className="flex flex-col"></div>
                    {event.attribute_EventCategory && (
                      <div class="px-5 pb-2 flex-shrink-0 sm:mr-4">
                        <div className="sm:hidden pb-2 flex justify-end w-full">
                          <a
                            href={
                              event.attribute_FreeEvent
                                ? `/visit/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                                : `/event/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              handleLinkClick(
                                event.attribute_FreeEvent
                                  ? `/visit/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`
                                  : `/event/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`,
                                event.start,
                                event.id,
                                event.name
                              );
                            }}
                            className="block max-w-[400px] ml-auto"
                          >
                            <img
                              src={event.imageUrl}
                              alt={event.name}
                              className="object-cover"
                              style={{
                                width: "100%", // Set width to 100%
                                objectFit: "cover",
                                maxHeight: "800px",
                                objectPosition: "top", // Position the image at the top
                              }}
                            />
                          </a>
                        </div>
                        <p
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontStyle: "italic",
                          }}
                        >
                          {event.attribute_EventCategory}
                        </p>
                      </div>
                    )}
                    {/* Render start times for the specific day of the event */}
                    {eventInstances[event.id] && (
                      <p
                        className="px-5 pb-2"
                        style={{
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          textTransform: "uppercase",
                          fontStyle: "italic",
                        }}
                      >
                        {/* Render start times for the specific day of the event */}
                        {Object.values(
                          _.groupBy(eventInstances[event.id], (instance) =>
                            new Date(instance.start).toLocaleDateString()
                          )
                        ).map((instancesByDay) => {
                          return instancesByDay
                            .map((instance, index) => {
                              const instanceDate = new Date(
                                instance.start
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                              });
                              const eventDate = new Date(
                                event.start
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                              });
                              const isSameDay = instanceDate === eventDate;

                              {
                                /**   if (isSameDay) {
                                  // Return only the start time for the first two instances
                                  if (isSameDay && index < 2) {
                                  // Only include start times for the first two instances
                                   renderedTimes.push(getTimeNumber(instance.start));
                                   } else if (isSameDay && index === 2) {
                                   // Include a message for more instances beyond the first two
                                  renderedTimes.push("and more...");
                                  }
                              }   */
                              }

                              if (isSameDay) {
                                if (index === 0) {
                                  // If it's the first instance of the day, format the date
                                  return `${formatDate(event.start)}`;
                                } else if (
                                  event.start !== instancesByDay[index].start
                                ) {
                                  // If it's not the first instance of the day, format the time of the following instance
                                  return `${getTimeNumber(
                                    instancesByDay[index].start
                                  )}`;
                                }
                              }
                              return null; // Ignore instances with different dates
                            })
                            .filter(Boolean)
                            .join(" & ");
                        })}
                      </p>
                    )}
                    <div class="flex flex-row space-x-2 px-5 pb-3">
                      {/* Conditionally render tag 1 if it's not null */}
                      {event.attribute_EventTag1 && (
                        <div className="text-align-center">
                          <label
                            class="bg-red-600"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "5px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: "0.5rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              paddingBottom: "3px",
                            }}
                          >
                            {event.attribute_EventTag1}
                          </label>
                        </div>
                      )}
                      {/* Conditionally render tag 2 if it's not null */}
                      {event.attribute_EventTag2 && (
                        <div className="text-align-center">
                          <label
                            class="bg-zinc-800"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "2px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: "0.5rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              paddingBottom: "3px",
                            }}
                          >
                            {event.attribute_EventTag2}
                          </label>
                        </div>
                      )}
                      {/* Conditionally render tag 3 if it's not null */}
                      {event.attribute_EventTag3 && (
                        <div className="text-align-center">
                          <label
                            class="bg-customBlue"
                            style={{
                              padding: "3px",
                              width: "auto",
                              height: "2px",
                              fontWeight: "lighter",
                              color: "white",
                              letterSpacing: "2px",
                              lineHeight: "1",
                              fontSize: "0.5rem",
                              background: "#2D2D2D",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              paddingBottom: "3px",
                            }}
                          >
                            {event.attribute_EventTag3}
                          </label>
                        </div>
                      )}
                    </div>
                    <div class="px-5 pb-2">
                      {event.name && (
                        <h3
                          className="text-3xl text-left"
                          style={{
                            fontFamily: "Norwester, Poppins, sans-serif",
                            textTransform: "uppercase",
                            fontStyle: "normal",
                            lineHeight: "1", // Increase the line height (leading)
                          }}
                        >
                          {event.name}
                        </h3>
                      )}
                    </div>
                    <div class="px-5 pb-2">
                      {event.attribute_Subtitle && (
                        <div class="text-left text-2xl font-semibold">
                          <h4
                            style={{
                              fontFamily: "Norwester, Poppins, sans-serif",
                              textTransform: "uppercase",
                              fontStyle: "normal",
                              paddingBottom: "3px",
                              margin: "0", // Add margin
                              lineHeight: "1", // Increase the line height (leading)
                            }}
                          >
                            {event.attribute_Subtitle}
                          </h4>
                        </div>
                      )}
                      {event.attribute_FeaturedArtists && (
                        <div class="pb-2">
                          <h1 class="text-left" style={{ margin: "0" }}>
                            <p
                              style={{
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "none",
                                fontStyle: "normal",
                                paddingBottom: "3px",
                                margin: "0", // Add margin
                              }}
                            >
                              {event.attribute_FeaturedArtists}
                            </p>
                          </h1>
                        </div>
                      )}
                      {event.attribute_SpecialInformation && (
                        <div class="pb-2">
                          <h1 class="text-left" style={{ margin: "0" }}>
                            <p
                              style={{
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "none",
                                fontStyle: "normal",
                                paddingBottom: "3px",
                                margin: "0", // Add margin
                              }}
                            >
                              {event.attribute_SpecialInformation}
                            </p>
                          </h1>
                        </div>
                      )}
                    </div>

                    <div class="px-5">
                      <div className="flex flex-grid grid-cols-3 items-center">
                        {allSoldOut ? (
                          <a
                            href={
                              event.attribute_FreeEvent
                                ? `/visit/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                                : `/event/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              handleLinkClick(
                                event.attribute_FreeEvent
                                  ? `/visit/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`
                                  : `/event/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`,
                                event.start,
                                event.id,
                                event.name
                              );
                            }}
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              letterSpacing: "2.5px",
                              fontSize: "1rem",
                              height: "40px",
                              background: "#B00000",
                              border: "none",
                              borderRadius: "none",
                              display: "flex",
                              lineHeight: "1.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "25px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textDecoration: "none", // Ensure no underline for anchor tag
                            }}
                          >
                            Sold Out
                          </a>
                        ) : (
                          // Render the regular button for buying tickets
                          <a
                            href={
                              event.attribute_FreeEvent
                                ? `/visit/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                                : `/event/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              handleLinkClick(
                                event.attribute_FreeEvent
                                  ? `/visit/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`
                                  : `/event/${event.id
                                      .substring(0, 5)
                                      .toLowerCase()}/`,
                                event.start,
                                event.id,
                                event.name
                              );
                            }}
                            style={{
                              width: "auto",
                              maxWidth: "100%", // Ensure button doesn't overflow its container
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              letterSpacing: "2.5px",
                              fontSize: "1rem", // Increased font size for the button text
                              height: "40px", // Adjust height to fit content
                              background: "#009ED0",
                              border: "none",
                              borderRadius: "none",
                              display: "flex",
                              lineHeight: "1.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "25px", // Adjusted padding to keep consistent
                              whiteSpace: "nowrap", // Prevent text from wrapping
                              overflow: "hidden", // Hide overflowing text
                              textOverflow: "ellipsis", // Show ellipsis for overflow
                              textDecoration: "none", // Ensure no underline for anchor tag
                            }}
                          >
                            {loading
                              ? "Loading..."
                              : event.attribute_FreeEvent
                              ? "Event Info"
                              : "Buy Tickets"}
                          </a>
                        )}

                        {event.attribute_FreeEvent ? (
                          <div className="" style={{ flex: "1" }}>
                            {/* Empty div to maintain grid layout */}
                          </div>
                        ) : (
                          <div
                            className="mx-2.5"
                            style={{
                              flex: "1",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "none",
                              fontWeight: "normal",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {event.prices
                              ? `$${event.prices} (+$${parseFloat(
                                  event.commission
                                ).toFixed(2)} fee)`
                              : ""}
                          </div>
                        )}
                      </div>
                    </div>

                    <section class="px-5">
                      <div class="flex flex-row space-x-1">
                        {instancesOnDayAndEventId.map((event, index, array) => (
                          <div key={event.instanceId} class="">
                            {event.availableStatus === 0 && !allSoldOut && (
                              <div class="pt-4">
                                <label
                                  style={{
                                    width: "auto",
                                    maxWidth: "100%",
                                    fontFamily:
                                      "Montserrat, Poppins, sans-serif",
                                    textTransform: "uppercase",
                                    fontStyle: "italic",
                                    fontSize: ".8rem",
                                    height: "30px",
                                    background: "#B00000",
                                    border: "none",
                                    borderRadius: "none",
                                    display: "flex",
                                    lineHeight: "1.5rem",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {getTimeNumber(event.start)} Sold Out
                                </label>
                              </div>
                            )}
                            <div key={event.instanceId} div class="">
                              {event.availableStatus > 0 &&
                                event.availableStatus <= 5 &&
                                !allSoldOut && (
                                  <div class="pt-4">
                                    <label
                                      style={{
                                        width: "auto",
                                        maxWidth: "100%",
                                        fontFamily:
                                          "Montserrat, Poppins, sans-serif",
                                        textTransform: "uppercase",
                                        fontStyle: "italic",
                                        fontSize: ".8rem",
                                        height: "30px",
                                        background: "#B00000",
                                        border: "none",
                                        borderRadius: "none",
                                        display: "flex",
                                        lineHeight: "1.5rem",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "10px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {getTimeNumber(event.start)} Few Tickets
                                      Remain
                                    </label>
                                  </div>
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                </div>

                <div
                  className="col-span-4 md:col-span-4 md:ml-auto"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    maxWidth: "100%",
                  }}
                >
                  <div
                    className=""
                    style={{
                      maxWidth: "400px",
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-end", // Align content to the center
                    }}
                  >
                    {event.imageUrl && (
                      <div
                        className="hidden md:block"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <a
                          href={
                            event.attribute_FreeEvent
                              ? `/visit/${event.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`
                              : `/event/${event.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick(
                              event.attribute_FreeEvent
                                ? `/visit/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`
                                : `/event/${event.id
                                    .substring(0, 5)
                                    .toLowerCase()}/`,
                              event.start,
                              event.id,
                              event.name
                            );
                          }}
                        >
                          <img
                            src={event.imageUrl}
                            alt={event.name}
                            className="object-cover"
                            style={{
                              width: "100%", // Set width to 100%
                              height: "100%", // Set height to 100%
                              objectFit: "cover",
                              objectPosition: "top", // Position the image at the top
                            }}
                          />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {!isLastEventInMonth(event) && (
                <div
                  className="w-full h-px my-4 opacity-10"
                  style={{
                    background:
                      "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                  }}
                />
              )}
            </li>
          </div>
        ) : null;
      }
      return null;
    }

    return (
      <div key={monthYear}>
        <div className="">
          <div className="relative flex items-center space-x-5 divide-slate-300/60">
            <span className="sm:mr-5">
              <p
                className="uppercase tracking-tighter sm:text-3xl"
                id="cMonth"
                style={{
                  fontFamily: "Montserrat, Poppins, sans-serif",
                  textTransform: "uppercase",
                  fontWeight: "normal",
                  whiteSpace: "nowrap",
                  width: "8ch",
                }}
              >
                {formatMonthYearDisplay(monthYear)}
              </p>
            </span>
            <div className="flex-grow border border-white"></div>
          </div>
        </div>
        {/* Render events for this month */}
        {orderedByDay.map((event) => checkEventInUniqueMonths(event))}
      </div>
    );
  });

  return (
    <>
      <div className="antialiased">
        {view === "List" ? (
          <div>
            <EventNavBarList
              filterValueSelected={onFilterValueSelected}
              filterValueTwoSelected={onFilterValueTwoSelected}
              viewValueSelected={onViewValueSelected}
              filterTextValue={filterTextValue}
              filterTextValueTwo={filterTextValueTwo}
            />
            <div class="text-xl sm:text-3xl mb-4 sm:mb-8 mt-3">
              <h2
                className="uppercase"
                style={{
                  fontFamily: "Norwester, Poppins, sans-serif",
                  textTransform: "uppercase",
                  fontWeight: "normal",
                }}
              >
                Upcoming Events
              </h2>
            </div>
            {/* Render the loading spinner or NoMatch component here */}
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div
                className="grid grid-cols-10 results-list"
                style={{
                  lineHeight: "1",
                }}
              >
                {noMatchView ? (
                  handleNoMatch()
                ) : (
                  <span class="">
                    <ul class="">{listItems}</ul>
                  </span>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="">
            <CalendarView viewValueSelected={onViewValueSelected} />
          </div>
        )}
      </div>
    </>
  );
};
